(function () {
  const priceElements = document.querySelectorAll('[data-live-product-price]');

  if (!priceElements.length) return;

  const cache = new Map();

  function formatPrice(amount, currency = 'EUR') {
    return new Intl.NumberFormat('de-DE', {
      style: 'currency',
      currency: currency
    }).format(amount);
  }

  function getSolagoProduct(handle) {
    const cacheKey = `solago:${handle}`;

    if (!cache.has(cacheKey)) {
      const request = fetch(
        `${window.Shopify.routes.root}products/${encodeURIComponent(handle)}.js`,
        {
          credentials: 'same-origin',
          headers: {
            Accept: 'application/json'
          }
        }
      ).then(response => {
        if (!response.ok) {
          throw new Error(`Produkt konnte nicht geladen werden: ${handle}`);
        }

        return response.json();
      });

      cache.set(cacheKey, request);
    }

    return cache.get(cacheKey);
  }

  async function updatePrice(element) {
    const shop = element.dataset.shop || 'solago';
    const handle = element.dataset.productHandle;

    if (!handle) return;

    /*
     * Solarhandel24 kommt anschließend dazu.
     * Aktuell erst einmal nur Produkte aus solago.de laden.
     */
    if (shop !== 'solago') return;

    try {
      const product = await getSolagoProduct(handle);

      if (typeof product.price_min !== 'number') {
        throw new Error(`Kein Preis gefunden: ${handle}`);
      }

      const currency =
        window.Shopify &&
        window.Shopify.currency &&
        window.Shopify.currency.active
          ? window.Shopify.currency.active
          : 'EUR';

      element.textContent = formatPrice(
        product.price_min / 100,
        currency
      );

      element.dataset.priceLoaded = 'true';
    } catch (error) {
      console.warn('[Dynamic Product Price]', error);
    }
  }

  priceElements.forEach(updatePrice);
})();